/**
 * Application configuration
 */
export const config = {
  api: {
    baseUrl: 'https://api.ollie.ae/api/v1',
    // baseUrl: 'http://localhost:8000/api/v1',
  },

  storage: {
    sessionIdKey: 'ollie_session_id',
    userPhoneKey: 'ollie_user_phone',
    userEmailKey: 'ollie_user_email',  // Optional email
    userProfileKey: 'ollie_user_profile',  // Stores nationality, employment, salary if provided
  },

  ui: {
    notification: {
      autoHideDuration: 4000, // milliseconds
    },

    loading: {
      stepDuration: 1000, // milliseconds between loading steps
    },
  },

  theme: {
    colors: {
      primary: {
        50: '#eef2ff',
        100: '#e0e7ff',
        500: '#6366f1',
        600: '#4f46e5',
        700: '#4338ca',
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        500: '#22c55e',
        600: '#16a34a',
      },
      warning: {
        50: '#fefce8',
        100: '#fef3c7',
        500: '#eab308',
        600: '#ca8a04',
      },
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        500: '#ef4444',
        600: '#dc2626',
      },
      gray: {
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        500: '#6b7280',
        600: '#4b5563',
        700: '#374151',
        800: '#1f2937',
      },
    },
  },
};

export default config;
